'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

import Expander from '../Expander.react';
import GoodSourceFilter from '../Filters/GoodSource.react';

import goodSources from '../../../tables/good-sources';

export default class GoodSource extends Component {
    static propTypes = {
        isExpander: PropTypes.bool,
    };

    static defaultProps = {
        isExpander: false,
    };

    render() {
        const { params, onChangeParams, isExpander } = this.props;

        let badge = <em data-active={false} />;

        // Find our activated good sources list
        const selectedGoodSources = Object.keys(goodSources).filter(key => {
            return params.filters && typeof params.filters[key] === 'object';
        });

        if (selectedGoodSources.length > 0) {
            badge = <em data-active={true}>{selectedGoodSources.length}</em>
        }

        const button = (
            <span className="global-search-filter-btn">
                Good Source of {badge}
            </span>
        );

        // If we're not filtering for plans, then the plan size filter is not active
        const isFilterAvailable = params.types.includes('recipe');

        if (!isFilterAvailable) {
            return <span />
        }

        return (
            <span className="global-search-hideable-filter" data-active={true}>
                <Expander button={button}>
                    <GoodSourceFilter params={params} onChangeParams={onChangeParams} />
                </Expander>
            </span>
        );
    }
}
